/**
 * Update x, y position of a window in a list of windows
 * @param mapId
 * @param x
 * @param y
 * @param windows
 * @returns {*}
 */
export const updateWindowPos = (mapId, x, y, windows) => {
    windows = windows.map((window) => {
        return {
            ...window,
            position: {
                x: window.mapId === mapId ? x : window.position.x,
                y: window.mapId === mapId ? y : window.position.y
            }
        }
    });

    return windows;
};

/**
 * Bring a window to the front of a list of windows
 * @param mapId
 * @param windows
 * @returns {*}
 */
export const bringWindowToFront = (mapId, windows) => {
    const index = windows.findIndex(window => window.mapId === mapId);
    let target = windows.splice(index, 1);
    if (target[0]) windows.push(target[0]);
    return windows;
};

export const getFrontWindow = (windows) => {
    return windows?.[windows.length - 1];
}

export const activateAxisEditing = (mapId, axisName, windows) => {
    return windows.map(window => {
        if (window.mapId === mapId) window.axisEditingAxisName = axisName;
        return window;
    })
};

export const deactivateAxisEditing = (mapId, windows) => {
    return windows.map(window => {
        if (window.mapId === mapId) delete window.axisEditingAxisName;
        return window;
    })
};

export const openWindow = (mapId, windows) => {
    const grid = 60; //60px width grid
    const occupied = windows.map(window => { return {y: Math.round(window.position.y / grid)} });
    let y = 0;

    //increment y until we find an empty grid position
    while(occupied.some(item => item.y === y)) { y++; }

    const window = {mapId, position: {x: 0, y: y * grid }};
    return [...windows, window];
}